export const WAND_VEGA_PROVIDER = 'wand_vega';

export const WAND_VEGA_MODELS = Object.freeze([
  Object.freeze({ id: '1.0-pro', name: 'Wand Vega 1.0 Pro' }),
  Object.freeze({ id: '1.5-pro', name: 'Wand Vega 1.5 Pro' }),
]);

// 测试期间按站内暂定价开放全部清晰度。
export const WAND_VEGA_RESOLUTIONS = Object.freeze(['720P', '1080P', '2K', '4K']);
export const WAND_VEGA_RATIOS = Object.freeze(['adaptive', '21:9', '16:9', '4:3', '1:1', '3:4', '9:16']);
// The upstream guide does not state a firm multi-reference ceiling. Keep this
// storyboard entry conservative until its supported count is confirmed.
export const WAND_VEGA_STORYBOARD_REFERENCE_LIMIT = 9;

export const isWandVegaModel = (model) => (
  WAND_VEGA_MODELS.some((item) => item.id === String(model || '').trim())
);

export const getWandVegaDurationLimits = (model) => ({
  min: 4,
  max: model === '1.5-pro' ? 30 : 15,
});

export const normalizeWandVegaResolution = (resolution) => {
  const value = String(resolution || '').trim().toUpperCase();
  return WAND_VEGA_RESOLUTIONS.includes(value) ? value : '1080P';
};

export const normalizeWandVegaRatio = (ratio) => {
  const value = String(ratio || '').trim().toLowerCase();
  return WAND_VEGA_RATIOS.includes(value) ? value : 'adaptive';
};

export const isPublicWandVegaImageUrl = (value) => {
  try {
    const url = new URL(String(value || '').trim());
    const host = url.hostname.toLowerCase();
    return ['http:', 'https:'].includes(url.protocol)
      && !url.username
      && !url.password
      && !url.hash
      && host.includes('.')
      && !host.endsWith('.localhost')
      && !host.endsWith('.local')
      && !host.endsWith('.internal')
      && !host.endsWith('.test')
      && !host.endsWith('.invalid')
      && !/^[0-9.]+$/.test(host)
      && !host.includes(':');
  } catch {
    return false;
  }
};

export const buildWandVegaStoryboardRequest = ({ model, prompt, duration, resolution, ratio, references = [] }) => {
  if (!isWandVegaModel(model)) throw new Error('Wand Vega 请选择 1.0 Pro 或 1.5 Pro');
  const seconds = Number(duration);
  const limits = getWandVegaDurationLimits(model);
  if (!Number.isInteger(seconds) || seconds < limits.min || seconds > limits.max) {
    throw new Error(`Wand Vega ${model} 只能生成 ${limits.min}–${limits.max} 秒；请调整当前分镜组时长，不会自动压缩剧情`);
  }
  if (!WAND_VEGA_RESOLUTIONS.includes(String(resolution || '').trim().toUpperCase())) {
    throw new Error('Wand Vega 清晰度无效，请选择 720P、1080P、2K 或 4K');
  }
  if (!WAND_VEGA_RATIOS.includes(String(ratio || '').trim().toLowerCase())) {
    throw new Error('Wand Vega 视频比例无效，请重新选择');
  }
  if (references.length > WAND_VEGA_STORYBOARD_REFERENCE_LIMIT) {
    throw new Error(`Wand Vega 小故事板当前最多提交 ${WAND_VEGA_STORYBOARD_REFERENCE_LIMIT} 张参考图；请减少绑定，不会自动丢弃素材`);
  }
  const referenceUrls = references.map((item) => String(item?.url || '').trim());
  if (referenceUrls.some((url) => !isPublicWandVegaImageUrl(url))) {
    throw new Error('Wand Vega 参考图需要原始公网 HTTP(S) URL；仅有素材库 ID、Base64 或本地地址时请重新选择原图');
  }
  if (!String(prompt || '').trim() && !referenceUrls.length) {
    throw new Error('Wand Vega 请提供视频提示词或参考图');
  }
  return {
    provider: WAND_VEGA_PROVIDER,
    model,
    prompt: String(prompt || '').trim(),
    duration: `${seconds}s`,
    resolution: String(resolution).trim().toUpperCase(),
    ratio: String(ratio).trim().toLowerCase(),
    generationMode: referenceUrls.length ? 'reference' : 'text2video',
    referenceUrls,
  };
};
